interface DollarBillProps {
  x: number;
  y: number;
  rotation: number;
  width: number;
  height: number;
  fillColor: string;
  strokeColor: string;
}

export function DollarBillSvg(props: DollarBillProps) {
  const { x, y, rotation, width, height, fillColor, strokeColor } = props;

  const gradientId = `bill-gradient-${x}-${y}`;
  const shadowId = `bill-shadow-${x}-${y}`;

  return (
    <g transform={`translate(${x}, ${y}) rotate(${rotation}, ${width / 2}, ${height / 2})`}>
      <defs>
        {/* Gradient for paper depth */}
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={fillColor} stopOpacity="1" />
          <stop offset="40%" stopColor={fillColor} stopOpacity="0.95" />
          <stop offset="60%" stopColor={fillColor} stopOpacity="0.85" />
          <stop offset="100%" stopColor={fillColor} stopOpacity="0.9" />
        </linearGradient>

        {/* Shadow filter */}
        <filter id={shadowId} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="0.5" />
          <feOffset dx="0.5" dy="1" result="offsetblur" />
          <feComponentTransfer>
            <feFuncA type="linear" slope="0.3" />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Main bill body with curved edges */}
      <path
        d={`
          M 2 ${height * 0.3}
          Q 0 ${height * 0.15} 2 2
          Q ${width * 0.15} 0 ${width * 0.5} 1
          Q ${width * 0.85} 2 ${width - 2} 2
          Q ${width} ${height * 0.15} ${width - 2} ${height * 0.3}
          L ${width - 1} ${height * 0.7}
          Q ${width} ${height * 0.85} ${width - 2} ${height - 2}
          Q ${width * 0.85} ${height} ${width * 0.5} ${height - 1}
          Q ${width * 0.15} ${height - 2} 2 ${height - 2}
          Q 0 ${height * 0.85} 2 ${height * 0.7}
          Z
        `}
        fill={`url(#${gradientId})`}
        stroke={strokeColor}
        strokeWidth="0.8"
        strokeOpacity="0.9"
        filter={`url(#${shadowId})`}
      />

      {/* Horizontal fold line (crease) */}
      <path
        d={`
          M ${width * 0.15} ${height / 2}
          Q ${width * 0.35} ${height / 2 - 1} ${width * 0.5} ${height / 2}
          Q ${width * 0.65} ${height / 2 + 1} ${width * 0.85} ${height / 2}
        `}
        stroke={strokeColor}
        strokeWidth="0.3"
        opacity="0.2"
        fill="none"
      />

      {/* Subtle corner highlights */}
      <ellipse cx={width - 6} cy={6} rx="2" ry="1.5" fill="white" opacity="0.15" />
      <ellipse cx={6} cy={height - 6} rx="1.5" ry="2" fill="white" opacity="0.12" />

      {/* Dollar sign */}
      <text
        x={width / 2}
        y={height / 2}
        textAnchor="middle"
        dominantBaseline="middle"
        fill={strokeColor}
        fontSize="10"
        fontWeight="bold"
        opacity="0.8"
      >
        $
      </text>
    </g>
  );
}
